import React from "react";

function GroupHeaderActions({ onInfo, isGroup }) {
  if (!isGroup) return null; 
  return (
    <button className="btn btn-sm btn-light" onClick={onInfo} title="Group Info">
      👥
    </button>
  );
}

export default GroupHeaderActions;